import { enableProdMode, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { HTTP_INTERCEPTORS, provideHttpClient, withXhr, withInterceptorsFromDi } from '@angular/common/http';
import { MarkdownModule } from 'ngx-markdown';

import { environment } from './environments/environment';
import { AuthInterceptor } from './app/core/auth/auth.interceptor';
import { routes } from './app/app-routing/app-routing.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    // `ngx-markdown@16` predates its `provideMarkdown()` helper (added in
    // later majors that also require a `marked` major bump out of scope for
    // this standalone-only migration, per ADR-0007's blast-radius limit) —
    // `importProvidersFrom(MarkdownModule.forRoot())` is Angular's own
    // supported interop path for registering a legacy NgModule's providers
    // once, at the root, from a standalone bootstrap. This replaces the
    // previous per-feature `MarkdownModule.forRoot()` call that lived only
    // in `ExerciseModule`.
    importProvidersFrom(MarkdownModule.forRoot()),
  ],
});
